
import { useState, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export default function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
  className = '',
  error,
  ...rest
}: InputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password';
  const inputType = isPasswordField ? (showPassword ? 'text' : 'password') : type;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2 font-sans">
          {label} {required && <span className="text-orange-500">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          className={`w-full px-4 py-3 border border-gray-200 rounded-card focus:border-green-500 focus:outline-none transition-colors text-sm bg-white shadow-soft font-sans ${error ? 'border-orange-500' : ''} ${isPasswordField ? 'pr-12' : ''}`}
          {...rest}
        />
        {isPasswordField && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors focus:outline-none focus:text-green-500"
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          >
            <i className={`ri-${showPassword ? 'eye-off' : 'eye'}-line text-lg`}></i>
          </button>
        )}
      </div>
      {error && (
        <p className="text-orange-500 text-xs mt-1 font-sans">{error}</p>
      )}
    </div>
  );
}